var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aplayer-volume-wrap"},[_c('icon-button',{class:("aplayer-icon-" + _vm.volumeIcon),attrs:{"icon":_vm.volumeIcon},nativeOn:{"click":function($event){_vm.$emit('togglemute')}}}),_vm._v(" "),_c('div',{staticClass:"aplayer-volume-bar-wrap",on:{"mousedown":_vm.onBarMouseDown}},[_c('div',{ref:"bar",staticClass:"aplayer-volume-bar"},[_c('div',{staticClass:"aplayer-volume",style:({
          height: _vm.muted ? 0 : ((Math.trunc(_vm.volume * 100)) + "%"),
          background: _vm.theme
        })})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f2a61f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loader.js!./src/components/aplayer/components/aplayer-controller-volume.vue
// module id = Wj3X
// module chunks = 30